module.exports = new __parcel__URL__("Mintbase_logo.31d928c3.svg").toString();